import * as React from 'react';
import * as I18n from 'i18n-js';
import ModalDialog from '@reverbdotcom/commons/dist/components/modal_dialog';
import URLHelpers from '../components/shared/url_helpers';
import { APIRequest } from '../index';
import AlertBox from '@reverbdotcom/commons/dist/components/alert_box';
import { ICreditCard } from '../schemas/core-schema';
import Location from '../lib/wrapped_location';

interface IProps {
  creditCard: ICreditCard,
  changePaymentPath: string,
}

export default function CheckoutDeleteCreditCardButton({ creditCard, changePaymentPath }: IProps) {
  const [isModalOpen, toggleModalOpen] = React.useState(false);
  const [hasCardRemovalFailed, toggleCardRemovalFailure] = React.useState(false);
  const [isLoading, toggleLoading] = React.useState(false);
  const closeModal = () => {
    toggleModalOpen(false);
  };

  const deleteCard = async () => {
    toggleLoading(true);
    toggleCardRemovalFailure(false);
    try {
      await APIRequest.V3.destroy(URLHelpers.myCreditCardPath(creditCard.id));
      Location.assign(changePaymentPath);
    } catch {
      toggleCardRemovalFailure(true);
    } finally {
      toggleLoading(false);
    }
  };

  const RenderConfirmDeleteCardModal = () => {
    return (
      <ModalDialog
        headerTitle={I18n.t('discovery.bundledCheckout.deleteCreditCard.deleteCreditCard')}
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        onSubmit={deleteCard}
        isSaving={isLoading}
        containsFormElement
        data-confirm-delete-card-modal
      >
        {I18n.t(
          'discovery.bundledCheckout.deleteCreditCard.areYouSureYouWantToDeleteYourCard',
          { cardLast4Digits: creditCard.last_4 },
        )}

        {hasCardRemovalFailed &&
          <AlertBox type="error" small>
            {I18n.t('discovery.bundledCheckout.deleteCreditCard.failedToDeleteCardErrorMessage')}
          </AlertBox>
        }
      </ModalDialog>
    );
  };

  const RenderDeleteCreditCardButton = () => {
    return (
      <button
        className="icon-l-trash button width-100"
        type="button"
        onClick={() => toggleModalOpen(true)}
        data-delete-credit-card-button
      >
        {I18n.t('discovery.bundledCheckout.deleteCreditCard.deleteCard')}
      </button>
    );
  };

  return (
    <>
      {RenderDeleteCreditCardButton()}
      {RenderConfirmDeleteCardModal()}
    </>
  );
}



// WEBPACK FOOTER //
// ./node_modules/@reverbdotcom/discovery-ui/src/credit_cards/checkout_delete_credit_card_button.tsx